import { ThunkAction, ThunkDispatch } from 'redux-thunk';

import { store } from '../../../../store/configuration';

import { IApiError, TAppError } from '../../../../store/types';
import { AccessControlActionsValues, TAccessControlActions } from '../types/accessControl.types';
import { IAdvancedRole } from '../models/advancedRole.model';
import { IFeature } from '../models/features.model';
import { IDashboardConfig } from '../../../../store/models';

import { TAppState } from '@/store/reducers/reducers';

import { RoleServices } from '@/services/RoleServices';

export function getAccessControlConfig(): ThunkAction<Promise<void>, TAppState, {}, TAccessControlActions> {
  const request = (): TAccessControlActions => ({
    type: AccessControlActionsValues.GET_ACCONFIG,
  });

  const fail = (error: TAppError): TAccessControlActions => ({
    type: AccessControlActionsValues.GET_ACCONFIG_FAILED,
    error: error as IApiError,
  });

  const success = (
    config: IAdvancedRole<IFeature>[],
    features: IFeature[],
    option?: {
      actions: string[];
    },
  ): TAccessControlActions => ({
    type: AccessControlActionsValues.GET_ACCONFIG_SUCCESS,
    shouldSkipToaster: true,
    config,
    features,
    option,
  });

  return async (dispatch: ThunkDispatch<TAppState, {}, TAccessControlActions>): Promise<void> => {
    dispatch(request());
    try {
      const config = await RoleServices.GetAllRoles(true);
      const features = await RoleServices.GetAllFeatures();
      const dashboardConfig = store.getState()?.dashboardConfig?.config as IDashboardConfig;
      const actions = dashboardConfig?.settings?.users.actions;
      dispatch(success(config, features, { actions }));
    } catch (error) {
      dispatch(fail(error));
    }
  };
}
